import { Button, Grid, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { textFieldDefaultStyle } from '../../../../components/UI/Typography';

export const GridContainer = styled(Grid)(() => ({
  paddingLeft: '3rem',
}));

export const ReportTitle = styled(Typography)(({ theme }) => ({
  margin: '28px 0',
  fontSize: '21px',
  fontWeight: '600',
  color: '#707070',
  textTransform: 'uppercase',
  borderBottom: `2px solid ${theme.palette.secondary.main}`,
  width: 'fit-content',
}));

export const ShortAnswerTextField = styled(TextField)(() => ({
  ...textFieldDefaultStyle,
  width: '100%',
  margin: '8px',
}));

export const FlexCenterGrid = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: '20px',
  marginLeft: '0',
  borderRadius: '10px',
  width: '70%',
  border: `2px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
  fontWeight: '600',
}));
